import EmbedPicker from './embed-picker';
import TimePicker from './time-picker';
import './styles/index.scss';
const ExpandedTimePicker = TimePicker;
TimePicker.displayName = 'TimePicker';
ExpandedTimePicker.EmbedPicker = EmbedPicker;
export { EmbedPicker };
export default ExpandedTimePicker;
